import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { useDataContext } from "../../../context/index";
import useWelcomeCtr from "../../../controller/use-welcom-ctr";
import { logout } from "../../../redux/actions/acounts-action";
import { rootState } from "../../../redux/reducers";
import logoLettre from "../../../resources/images/logo-lettre.svg";
import { fileUrl } from "../../../utils";
import BlockNotif from "../../widget/block-notif/index";
import { BlockMessage } from "../bloc-message-notif";
import { useKeycloak } from "@react-keycloak/web";

export default function Header(props: any) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  const { keycloak } = useKeycloak();
  const { stopEvtSource } = useDataContext();

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const userState = useSelector((state: rootState) => state.userReducer);
  const { getStarted, goLogin } = useWelcomeCtr();
  const history = useHistory();
  const dispatch = useDispatch();

  const cb = async (params: boolean) => {
    if (params) {
      stopEvtSource();
      await keycloak.logout({redirectUri:"/"});
    }
  };
  const logOut = () => {
    dispatch(logout(cb));
  };

  const goToCommunityHome = () => {
    history.push("/community/home");
  };

  const showDiscussion = () => {
    history.push("/contact/discussion");
  };

  return (
    <div className="principalMenu">
      <div className="container mx-auto">
        <div className="leftItemHeader">
          <div className="logoHeader">
            <img
              src={logoLettre}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/")}
            />
          </div>
          <div className="menuDynamic tl">
            <div className="item">
              <Link to="/community/home" className="parent linkHeader">
                Community
              </Link>
              <div className="submenu">
                <div className="title">
                  <div className="container mx-auto">
                    <span
                      onClick={() => {
                        goToCommunityHome();
                      }}
                    >
                      Community
                    </span>
                    Join a global community for software publishers (ISVs).
                  </div>
                </div>
                <div className="container mx-auto">
                  <Link
                    className="linkHeader"
                    to="/community/discussions-categories"
                  >
                    <span className="name">Forum discussions</span>
                    <p>
                      Discuss the business challenges of your software company
                      with peers and industry experts.
                    </p>
                  </Link>
                  <Link
                    className="linkHeader"
                    to="/community/article-category/0/0"
                  >
                    <span className="name">Articles</span>
                    <p>
                      Share your expertise and insights to help software
                      publishers with high-value content.
                    </p>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item hidden">
              <a href="javascript:;" className="linkHeader parent">
                Marketplace
              </a>
              <div className="submenu">
                <div className="title">
                  <div className="container mx-auto">
                    <span>Marketplace</span>
                    Identify partnership opportunities with resellers, investors
                    and other professionals working in the software industry.
                  </div>
                </div>
                <div className="container mx-auto"></div>
              </div>
            </div>
            <div className="item">
              <Link to="/ma/home" className={`parent linkHeader`}>
                Corporate development
              </Link>
              <div className="submenu">
                <div className="title">
                  <div className="container mx-auto">
                    <span>Corporate development</span>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </div>
                </div>
                <div className="container mx-auto">
                  <Link to="/ma/home" className="linkSubMenu linkHeader">
                    <span className="name">M&A</span>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt.
                    </p>
                  </Link>
                  <Link
                    to={"/alternative-financing/home"}
                    className="linkSubMenu linkHeader"
                  >
                    <span className="name">Alternative financing</span>

                    <p>
                      Fund your business leveraging alternative solutions to
                      standard equity investments and loans.
                    </p>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item">
              <Link className={`parent linkHeader `} to="/events/all-events">
                Events
              </Link>
            </div>
          </div>
        </div>
        <div className="rightItemHeader">
          {keycloak && keycloak.token? (
            <div className="menuDynamic tr">
              <div className="item">
                <Link to="/dashboard" className="linkHeader">
                  <span className="icon-home"></span>
                  <span className="mobile">Home</span>
                </Link>
              </div>
              <div
                className="item"
                onClick={(e: any) => {
                  showDiscussion();
                }}
              >
                <BlockMessage unread={props.unread} />
              </div>
              <BlockNotif />
              <div className="item">
                <a href="javascript:;" className="parent linkHeader">
                  <div className={`profilImg`}>
                    <img
                      alt="Profile"
                      src={`${fileUrl(userState.file_name)}`}
                    />
                  </div>
                  <span className="mobile">My account</span>
                </a>
                <div className="submenu">
                  <Link to="/profil">Profile</Link>
                  <Link to="/settings">Account settings</Link>
                  <a
                    href="javascript:;"
                    onClick={(e) => {
                      e.preventDefault();
                      logOut();
                    }}
                  >
                    Sign out
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="menuDynamic tr notConnected">
              <div className="item">
                <a
                  href="javascript:;"
                  className="signinHeader"
                  onClick={(e) => {
                    e.preventDefault();
                    goLogin();
                  }}
                >
                  Sign in
                </a>
              </div>
              <div className="item">
                <a
                  href="javascript:;"
                  className="getstartedHeader"
                  onClick={(e) => {
                    e.preventDefault();
                    getStarted();
                  }}
                >
                  Get started
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
